import { Loader2 } from 'lucide-react';

import { useCustomerSettings } from '@/hooks/useCustomerSettings';
import { BillingNotifications } from './panels';
import TextMessagingPanel from './TextMessagingPanel';

/**
 * Settings → Notifications & mailing. Email statement/reminder toggles, paper
 * (postal) mail toggles, billing-contact emails, and recipient routing.
 * Admin-only edit; members see it read-only.
 */
export default function NotificationsTab() {
  const { data, isLoading, error } = useCustomerSettings();

  if (isLoading) {
    return (
      <div className="flex items-center gap-2 px-1 text-sm tracking-tight text-slate-900">
        <Loader2 size={14} className="animate-spin" /> Loading notifications…
      </div>
    );
  }
  if (error) {
    return (
      <div className="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm tracking-tight text-red-700">
        {error instanceof Error ? error.message : 'Failed to load settings.'}
      </div>
    );
  }
  if (!data) return null;

  return (
    <div className="space-y-6">
      <BillingNotifications data={data} />
      <TextMessagingPanel />
    </div>
  );
}
